import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "shared"
}
const _hoisted_2 = {
  class: "icon-wrapper",
  style: {"background":"var(--success-50)","border-color":"#DBE9E0"}
}
const _hoisted_3 = { class: "shared-block pointer" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = {
  key: 1,
  class: "shared pointer"
}
const _hoisted_7 = {
  class: "icon-wrapper",
  style: {"background":"#F5F5F5","border-color":"#DBE9E0"}
}
const _hoisted_8 = { class: "shared-block pointer" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "shared" }
const _hoisted_11 = {
  class: "icon-wrapper",
  style: {"background":"var(--success-50)","border-color":"#DBE9E0"}
}
const _hoisted_12 = { class: "shared-block pointer" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "description" }
const _hoisted_15 = { class: "shared pointer" }
const _hoisted_16 = {
  class: "icon-wrapper",
  style: {"background":"#F5F5F5","border-color":"#DBE9E0"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    class: "share-dropdown",
    placement: "bottom-start",
    "popper-class": "share-dropdown-popper",
    onCommand: $options.handleDropdown
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, { command: {shared: true} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Icon, {
                    icon: "globe-02",
                    stroke: "#079455",
                    width: "1.6rem",
                    height: "1.6rem"
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, " Anyone at " + _toDisplayString($options.company) + " with the link ", 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_14, " Anyone at " + _toDisplayString($options.company) + " with the link can view ", 1 /* TEXT */)
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_dropdown_item, {
            divided: "",
            command: {shared: false}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Icon, {
                    icon: "lock-01",
                    stroke: "#717680",
                    width: "1.6rem",
                    height: "1.6rem"
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "shared-block pointer" }, [
                  _createElementVNode("div", { class: "title" }, "Restricted"),
                  _createElementVNode("div", { class: "description" }, " Only you can access the link ")
                ], -1 /* HOISTED */))
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      (_ctx.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Icon, {
                icon: "globe-02",
                stroke: "#079455",
                width: "1.6rem",
                height: "1.6rem"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" Anyone at " + _toDisplayString($options.company) + " with the link ", 1 /* TEXT */),
                _createVNode(_component_Icon, {
                  stroke: "#535862",
                  width: "1.6rem",
                  height: "1.6rem",
                  icon: "chevron-down"
                })
              ]),
              _createElementVNode("div", _hoisted_5, " Anyone at " + _toDisplayString($options.company) + " with the link can view ", 1 /* TEXT */)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Icon, {
                icon: "lock-01",
                stroke: "#717680",
                width: "1.6rem",
                height: "1.6rem"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[0] || (_cache[0] = _createTextVNode(" Restricted ")),
                _createVNode(_component_Icon, {
                  stroke: "#535862",
                  width: "1.6rem",
                  height: "1.6rem",
                  icon: "chevron-down"
                })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "description" }, " Only you can access the link ", -1 /* HOISTED */))
            ])
          ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onCommand"]))
}